import { Button } from '@/components/ui/button';
import { Loader2, ChevronDown } from 'lucide-react';

interface LoadMoreButtonProps {
  loading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  totalShown: number;
  isLiteMode?: boolean;
}

export const LoadMoreButton = ({ 
  loading, 
  hasMore, 
  onLoadMore, 
  totalShown, 
  isLiteMode 
}: LoadMoreButtonProps) => {
  if (!hasMore) {
    return (
      <div className="text-center py-6">
        <p className="text-sm text-muted-foreground">
          {totalShown > 0 ? `End of feed • Showing ${totalShown} items` : 'No more items to load'}
        </p>
        {isLiteMode && (
          <p className="text-xs text-muted-foreground mt-1">
            ⚡ Lite mode active - reduced data usage
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="text-center py-6">
      <Button
        onClick={onLoadMore}
        disabled={loading}
        variant="outline"
        size="lg"
        className="min-w-32"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Loading...
          </>
        ) : (
          <>
            <ChevronDown className="w-4 h-4 mr-2" />
            Load More
          </>
        )}
      </Button>
      <p className="text-xs text-muted-foreground mt-2">
        Showing {totalShown} items{isLiteMode ? ' • Lite mode' : ''}
      </p>
    </div>
  );
};